import React from 'react';

export const Row = ({ style, children, noWrap, ...props }) => (
  <div style={{ display: 'flex', alignItems: 'center', flexWrap: noWrap ? '' : 'wrap', ...style }} {...props}> {children}</div>
);
